import React from 'react'
import { HeaderSide as Left, MuiButton, HeaderSide as Right, HeaderSide as Center, NumPoints, WrapWordsHeader, ReplyIcon, WrapAssessmentName, WrapMarkWordsContent, WrapHeaderActions, WrapFooter, WrapMarkWords, WrapScreenMarkWords } from './Style'
import { fieldsTyps } from 'components/Form'
import { CustomSection, LightButton, SpaceBetween, WrapHeader } from 'styles/GlobalStyle'
import { useMediaQuery } from '@mui/material'
import { useSelector } from 'react-redux'

const Header = (props) => {
    const { name, customHeader, toggleDrawer, category, contentToPrint, print, words, goRatingBtn, customGoBack } = props
    const { assessment } = useSelector(state => state.assessment)
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'), { noSsr: true })

    return (
        <div className='words-view-header-actions'>
            <Left side={"start"}>
                {isSmallScreen &&
                    <LightButton variant="solid" label="לתצוגת המבדק לחץ כאן" action={toggleDrawer(true)} />
                }
                {!assessment.reading_assessment_name && <WrapAssessmentName>{name}</WrapAssessmentName>}
                <SpaceBetween />
                {
                    customHeader?.left?.map((act, index) => {
                        const Component = fieldsTyps[act.component]
                        return (
                            act.width ?
                                <div style={{ width: act.width }}>
                                    <Component {...act} key={index} />
                                </div> :
                                <Component {...act} key={index} />
                        )
                    })
                }
            </Left>
            <Center side={"start"}>
                {
                    customHeader?.center?.map((act, index) => {
                        const Component = fieldsTyps[act.component]
                        return (
                            <Component {...act} key={index} />
                        )
                    })
                }
            </Center>
            <Right side={"end"}>
                {
                    customHeader?.right?.map((act, index) => {
                        const Component = fieldsTyps[act.component]
                        return (
                            act.width ?
                                <div style={{ width: act.width }}>
                                    <Component {...act} key={index} />
                                </div> :
                                <Component {...act} key={index} />
                        )
                    })
                }
            </Right>
        </div>
    )
}

export default Header
